'use client';

import ContactButtonsView from "@/app/__to_be_integrated/_____components/contact-buttons/view";
import { useContact } from "@/app/contexts/contact-context";
import ContactButtonsSkeleton from "@/app/__to_be_integrated/_____components/contact-buttons/Skeleton";

export default function ContactButtons() {
   const {
       isLoading
   } = useContact();

    if (isLoading) {
        return <ContactButtonsSkeleton />;
    } else {
        return <ContactButtonsView />
    }
}